/* ADD GROUPS */
export const LIST_REPORT9 = "LIST_REPORT9"
export const LIST_REPORT9_SUCCESS = "LIST_REPORT9_SUCCESS"
export const LIST_REPORT9_CLEAN = "LIST_REPORT9_CLEAN"
export const LIST_REPORT9_ERROR = "LIST_REPORT9_ERROR"
